@if (isWidgetActive()) {
    <div
        id="importSurveyData"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        #widget>
        <form
            id="importSurveyDataForm"
            name="importSurveyDataController.form"
            novalidate
            autocomplete="off">
            <div>
                <div
                    class="col-xs-12 widget-header"
                    cdkDragHandle>
                    <span>{{widgetConfig.header}}</span>
                    <div class="pull-right btn-group btn-group-xs">
                        <nlrp-help-link
                            [url]="helpLinkUrl"
                            [pageTitle]="helpPageTitle"></nlrp-help-link>
                        <i
                            class="nlrp-icon nlrp-18"
                            [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                            [title]="open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip"
                            (click)="toggleWidgetContentVisibility()">
                        </i>
                        <i
                            class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                            [title]="widgetConfig.closeTooltip"
                            id="importSurveyCloseBtn"
                            (click)="toggleWidgetVisibility()"></i>
                    </div>
                </div>
                @if (open) {
                    <div class="widget-content">
                        <div class="col-xs-12">
                            <h6>Destination / Plan Projected Coordinate System:</h6>
                        </div>
                        <div class="col-xs-12">
                            <div>
                                <input
                                    id="planCoordSystem"
                                    name="planCoordSystem"
                                    type="text"
                                    class="form-control"
                                    readonly="true"
                                    [value]="model" />
                            </div>
                            <li
                                role="presentation"
                                class="divider"></li>
                            <div class="mgt15">
                                <h6>Import file details</h6>
                            </div>
                        </div>
                        <div class="col-xs-12 mgt10">
                            <label
                                class="control-label"
                                for="fileType"
                                >File Type</label
                            >
                            <div class="input-group">
                                <ng-select
                                    class="nlr-ng-select"
                                    [searchable]="false"
                                    [clearable]="false"
                                    name="fileType"
                                    id="fileType"
                                    placeholder="Select"
                                    [items]="fileTypes"
                                    bindLabel="id"
                                    [(ngModel)]="selectedFileType"
                                    (change)="updateSelectedItem($event)"
                                    required>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-xs-12 mgt10">
                            <label
                                class="control-label"
                                for="filename"
                                >File Name</label
                            >
                            <div
                                class="input-group"
                                (click)="attachFileClick()">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-file"></i></span>
                                <input
                                    id="filename"
                                    name="filename"
                                    type="text"
                                    class="form-control"
                                    readonly="readonly"
                                    value="{{attachmentFilename}}" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-paper-clip"
                                        tabindex="0"></i>
                                </span>
                            </div>
                        </div>
                        @if (displayProjection) {
                            <div class="col-xs-12 mgt10 mgb10">
                                <label
                                    class="control-label"
                                    for="filename"
                                    >Coordinate System</label
                                >
                                <div class="input-group">
                                    <ng-select
                                        class="nlr-ng-select"
                                        [searchable]="false"
                                        [clearable]="false"
                                        name="projectedCoordSystem"
                                        id="projectedCoordSystem"
                                        placeholder="Select"
                                        [items]="filterProjectedCoordSystemList"
                                        [trackByFn]="projectedCoordSystemTrackBy"
                                        bindLabel="description"
                                        [(ngModel)]="projectedCoordSystem"
                                        (change)="updateProjectedCoordSystem($event)"
                                        required>
                                    </ng-select>
                                </div>
                            </div>
                        }
                        @if (fileTypeSelected.value.id === 'DWG') {
                            <div class="col-xs-12">
                                <label
                                    class="create-points-at-line-intersections"
                                    (click)="createInternalPointsChanged();">
                                    <i
                                        class="nlrp-icon nlrp-icon-check-box-unselected"
                                        [ngClass]="{'active': createInternalPoints,'nlrp-icon-check-box-selected': createInternalPoints,
                            'nlrp-icon-check-box-unselecte': !createInternalPoints}">
                                    </i>
                                    <span>Create points at line intersections</span>
                                </label>
                            </div>
                        }
                    </div>
                }
                <div class="col-xs-12 inline-bottom-buttons">
                    <button
                        class="btn btn-default nlr-btn-sm"
                        id="importCsdBtn"
                        (click)="submit()"
                        [disabled]="importBtnDisabled() || ((processing || attachmentFilename.length == 0) || (fileTypeSelected.value.projectionRequired === true && projectedCoordSystem === ''))">
                        Import
                    </button>
                    <button
                        class="btn btn-default nlr-btn-sm"
                        (click)="clear()"
                        id="resetBtn"
                        [disabled]="processing"
                        >Reset
                    </button>
                    <button
                        class="btn btn-default nlr-btn-sm"
                        id="closeBtn"
                        (click)="toggleWidgetVisibility()"
                        [disabled]="processing"
                        >Close
                    </button>
                </div>
                @if (processing) {
                    <div class="in-progress">
                        <label class="col-xs-12 control-label">{{lastMessage}}</label>
                    </div>
                }
            </div>
        </form>
    </div>
}
